<script setup lang="ts">
import ChargemapB2CSlider from '../ChargemapB2CSlider.vue'

defineProps({
    isDisabled: {
        type: Boolean,
        default: false
    }
})

const values = defineModel<number[]>({
    required: true
})

defineEmits(['change'])
</script>

<template>
    <div class="flex flex-col items-center justify-center text-center w-full">
        <h6
            class="w-full text-xs 425:text-sm font-medium tracking-wider text-header-dark text-center pt-1 pb-4 px-4 425:px-1 uppercase"
        >
            {{ $t('simulation.charge.battery.title') }}
        </h6>
        <div
            class="w-full border border-secondary-gray-disabled bg-white rounded-lg 425:rounded-2xl items-center justify-center p-4 425:p-6"
        >
            <ChargemapB2CSlider
                v-model="values"
                :labelMin="$n(values[0]! / 100, 'percent')"
                :labelMax="$n(values[1]! / 100, 'percent')"
                :min="0"
                :max="100"
                :step="1"
                :disabled="isDisabled"
                is-double
                @change="() => $emit('change')"
            />
        </div>
    </div>
</template>
